import { defineComponent as _defineComponent } from 'vue'
import SkillItem from '@/components/formats/RirekishoParts/SkillItem.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useDesignRirekishoSkills } from '@/composables/format-edit/useDesignRirekishoSkills'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekishoSkillsCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const descriptionMaxLength = 80
const formatData = useRirekishoFormatData()
const {
  activeHistoryItem,
  addSkills,
  deleteSkills,
  moveSkills,
  activateHistoryItem
} = useDesignRirekishoSkills(formatData)

return { __sfc: true,descriptionMaxLength, formatData, activeHistoryItem, addSkills, deleteSkills, moveSkills, activateHistoryItem, SkillItem }
}

})